{
  "userSettings": {
    "title": "Meine Einstellungen",
    "description": "Verwalte dein Profil und deine Einstellungen.",
    "tabs": {
      "profile": "Profil",
      "preferences": "Einstellungen",
      "security": "Sicherheit"
    },
    "profile": {
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "emailHelper": "Wende dich an deinen Organisationsmanager, um deine E-Mail zu ändern.",
      "role": "Stellenbezeichnung",
      "roleHelper": "Wende dich an deinen Organisationsmanager, um deine Stellenbezeichnung zu ändern.",
      "department": "Abteilung",
      "departmentHelper": "Wende dich an deinen Organisationsmanager, um deine Abteilung zu ändern.",
      "status": "Kontostatus",
      "organizationInfo": "Organisationsinformationen",
      "updateSuccess": "Profil erfolgreich aktualisiert",
      "updateError": "Profil konnte nicht aktualisiert werden"
    },
    "preferences": {
      "language": "Sprache",
      "languageHelper": "Wähle deine bevorzugte Sprache für die Oberfläche."
    },
    "security": {
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort bestätigen",
      "changePassword": "Passwort ändern",
      "passwordSuccess": "Passwort erfolgreich geändert",
      "passwordError": "Passwort konnte nicht geändert werden",
      "invalidCurrentPassword": "Aktuelles Passwort ist falsch",
      "passwordRequirements": "Passwortanforderungen",
      "minLength": "Mindestens 8 Zeichen lang",
      "requireLowercase": "Mindestens ein Kleinbuchstabe (a-z)",
      "requireUppercase": "Mindestens ein Großbuchstabe (A-Z)",
      "requireNumber": "Mindestens eine Ziffer (0-9)",
      "twoFactorTitle": "Zwei-Faktor-Authentifizierung (2FA)",
      "twoFactorDescription": "Schütze dein Konto mit einem Einmalcode aus einer Authenticator-App.",
      "twoFactorEnabled": "Zwei-Faktor-Authentifizierung ist aktiv",
      "setupTwoFactor": "2FA einrichten",
      "scanQrCode": "Scanne diesen QR-Code mit deiner Authenticator-App und gib dann den 6-stelligen Code ein.",
      "manualSecret": "QR-Code nicht scannbar? Geheimen Schlüssel für manuelle Eingabe anzeigen",
      "codeLabel": "6-stelliger Code",
      "verifyCode": "Code bestätigen",
      "removeTwoFactor": "2FA entfernen",
      "removeTwoFactorConfirm": "Dein Konto verlangt bei der Anmeldung keinen Einmalcode mehr. Bist du sicher?",
      "twoFactorSetupSuccess": "Zwei-Faktor-Authentifizierung aktiviert",
      "twoFactorSetupError": "Einrichtung der Zwei-Faktor-Authentifizierung fehlgeschlagen",
      "twoFactorRemoveSuccess": "Zwei-Faktor-Authentifizierung entfernt",
      "twoFactorRemoveError": "Entfernen der Zwei-Faktor-Authentifizierung fehlgeschlagen",
      "ssoManagedTitle": "Von deiner Organisation verwaltet",
      "ssoManagedDescription": "Dein Passwort und deine Zwei-Faktor-Authentifizierung werden von {{idpName}} verwaltet.",
      "ssoManagedFallbackIdp": "dem Identitätsanbieter deiner Organisation",
      "passwordUnavailable": "Passwortänderungen sind für dein Konto noch nicht verfügbar. Melde dich einmal per Single Sign-on an oder kontaktiere deinen Administrator.",
      "noPasswordSet": "Für dieses Konto ist kein Passwort gesetzt – eine Passwortänderung ist daher nicht möglich.",
      "statusError": "Sicherheitseinstellungen konnten nicht geladen werden.",
      "passkeysTitle": "Passkeys",
      "passkeysDescription": "Melde dich ohne Passwort an – mit Face ID, Touch ID oder einem Hardware-Sicherheitsschlüssel.",
      "addPasskey": "Passkey hinzufügen",
      "unnamedPasskey": "Passkey",
      "removePasskey": "Passkey entfernen",
      "removePasskeyConfirm": "Mit diesem Passkey ist keine Anmeldung mehr möglich. Bist du sicher?",
      "passkeyRemoveSuccess": "Passkey entfernt",
      "passkeyRemoveError": "Passkey konnte nicht entfernt werden",
      "reauthenticate": "Anmeldung bestätigen",
      "passkeyLinkError": "Passkey-Einrichtung konnte nicht gestartet werden",
      "passkeyPopupBlocked": "Dein Browser hat den Tab für die Passkey-Einrichtung blockiert. Bitte erlaube Pop-ups für diese Seite und versuche es erneut.",
      "stepUpTitle": "Kürzliche Anmeldung erforderlich",
      "stepUpDescription": "Zu deiner Sicherheit erfordern Änderungen an den Anmeldeeinstellungen eine kürzliche Anmeldung. Du wirst zur Bestätigung deiner Anmeldung weitergeleitet und kehrst danach hierher zurück.",
      "stepUpPasskeyDescription": "Zu deiner Sicherheit erfordert das Hinzufügen eines Passkeys eine kürzliche Anmeldung. Klicke nach der Bestätigung deiner Anmeldung erneut auf „Passkey hinzufügen“.",
      "stepUpSignInAgain": "Zu deiner Sicherheit erfordert diese Änderung eine kürzliche Anmeldung. Bitte melde dich ab und wieder an und versuche es dann erneut."
    }
  },
  "adminSettings": {
    "tenant": {
      "tabUsers": "Benutzer",
      "tabSettings": "Einstellungen",
      "slug": "Slug: {{slug}}",
      "addUser": "Benutzer hinzufügen",
      "columnName": "Name",
      "columnEmail": "E-Mail",
      "columnUserTypes": "Benutzertypen",
      "columnStatus": "Status",
      "columnClassification": "Klassifizierung",
      "sendInvitationAction": "Einladung senden",
      "resendInvitationAction": "Einladung erneut senden",
      "copyActivationLinkAction": "Aktivierungslink kopieren",
      "copyActivationLinkSuccess": "Aktivierungslink in die Zwischenablage kopiert",
      "copyActivationLinkFailed": "Aktivierungslink konnte nicht erstellt werden",
      "copyActivationLinkManual": "Diesen Aktivierungslink manuell kopieren",
      "resetSignInFailed": "Anmeldung konnte nicht zurückgesetzt werden",
      "deleteUserTitle": "Benutzer löschen",
      "deleteUserDescription": "Bist du sicher, dass du diesen Benutzer löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteUserSuccess": "Benutzer erfolgreich gelöscht",
      "deleteUserFailed": "Benutzer konnte nicht gelöscht werden",
      "sendInvitationSuccess": "Einladung erfolgreich gesendet",
      "sendInvitationFailed": "Einladung konnte nicht gesendet werden",
      "createdButInvitationFailed": "Benutzer erstellt, aber die Einladung konnte nicht gesendet werden – nutze \"Einladung erneut senden\"",
      "externalOrgRequired": "Externe Organisation ist für externe Benutzer erforderlich",
      "aiTitle": "KI-Funktionen",
      "aiDescription": "Steuere, ob KI-Funktionen für diesen Mandanten verfügbar sind.",
      "enableAILabel": "KI aktivieren",
      "enableAIDescription": "Hauptschalter für alle KI-Funktionen dieses Mandanten, etwa Bliksy, Schrittzusammenfassung und Diktieren. Gilt für Kunden- und Partner-Mandanten.",
      "saved": "Mandanten-Einstellungen gespeichert.",
      "saveFailed": "Mandanten-Einstellungen konnten nicht gespeichert werden.",
      "tabApps": "Apps",
      "tabUsage": "Nutzung",
      "appsDescription": "Verwalte, welche Apps dieser Mandant hat.",
      "addAppSuccess": "App erfolgreich hinzugefügt.",
      "addAppFailed": "Fehler beim Hinzufügen der App.",
      "removeAppSuccess": "App erfolgreich entfernt.",
      "removeAppFailed": "Fehler beim Entfernen der App.",
      "addApp": "App hinzufügen",
      "addAppNoCandidates": "Es sind keine weiteren Apps zum Hinzufügen verfügbar.",
      "noAppsAdded": "Diesem Mandanten wurde noch keine App hinzugefügt.",
      "appAllowed": "Darf die App nutzen",
      "appAllowedSaved": "Berechtigung gespeichert.",
      "appAllowedSaveFailed": "Fehler beim Speichern der Berechtigung.",
      "appSeats": "Plätze",
      "appSeatLimit": "Platzlimit",
      "seatLimitSaved": "Platzlimit gespeichert.",
      "seatLimitSaveFailed": "Fehler beim Speichern des Platzlimits.",
      "removeAppTitle": "App entfernen",
      "removeAppConfirm": "Beim Entfernen dieser App werden ihre mandantenspezifische Konfiguration verworfen und alle vergebenen Plätze freigegeben. Ein erneutes Hinzufügen stellt sie nicht wieder her.",
      "removeApp": "Aus Mandant entfernen",
      "appConfig": "Konfiguration",
      "appConfigPlannerEnabled": "Maßnahmen-Projektplaner",
      "appConfigSalesPartnerCompanyId": "HubSpot-Firma des Partners",
      "appConfigSalesPartnerCompanyIdHint": "Der Partner sieht nur Leads, die Mitarbeitende dieser Firma eingebracht haben. Gepflegt am Tenant, nicht hier.",
      "appConfigSalesPartnerCompanyIdMissing": "Am Tenant ist keine HubSpot-Firma verknüpft: der Partner sieht keine Leads und kann keine melden. Im Reiter „Allgemein“ setzen.",
      "appConfigUnreadable": "Gespeicherte Konfiguration ist nicht lesbar; Speichern ersetzt sie.",
      "appConfigure": "Konfigurieren",
      "appConfigTitle": "App-Konfiguration",
      "appConfigUnreadableDialog": "Es existiert eine gespeicherte Konfiguration, die mit dem aktuellen Schema nicht gelesen werden kann. Sie wird hier nicht angezeigt, und Speichern ersetzt sie.",
      "appConfigNorms": "Normen",
      "appConfigNormsPlaceholder": "Normen auswählen",
      "appConfigRequestAllowance": "Requests pro Vertragsjahr",
      "appConfigContractAnchor": "Vertragsbeginn",
      "appConfigContractAnchorPick": "Datum wählen",
      "appConfigContractAnchorPopup": "Kalender Vertragsbeginn",
      "appConfigContractAnchorFuture": "Der Vertragsbeginn darf nicht in der Zukunft liegen.",
      "appConfigSaved": "Konfiguration gespeichert.",
      "appConfigSaveFailed": "Konfiguration konnte nicht gespeichert werden.",
      "provisioningTitle": "Arbeitsbereiche für andere anlegen",
      "provisioningDescription": "Welche Arten von Arbeitsbereichen dieser Partner für andere anlegen und danach verwalten darf, z. B. aus der Sales-App heraus. Ohne Auswahl darf er keine anlegen."
    },
    "globalAi": {
      "title": "KI-Modelleinstellungen",
      "description": "Konfiguriere die KI-Modelle, die für alle Mandanten verwendet werden.",
      "highModelLabel": "High-Tier-Modell",
      "highModelDescription": "KI-Modell für komplexe Aufgaben (Bliksy-Agent, Omniscient).",
      "lowModelLabel": "Low-Tier-Modell",
      "lowModelDescription": "KI-Modell für einfache Aufgaben (Schrittzusammenfassungen, Bliksy-Unteraufgaben).",
      "transcriptionModelLabel": "Transkriptionsmodell",
      "transcriptionModelDescription": "Modell für die Sprache-zu-Text-Transkription.",
      "saved": "KI-Modelleinstellungen gespeichert.",
      "saveFailed": "KI-Modelleinstellungen konnten nicht gespeichert werden.",
      "featureOverride": {
        "title": "Funktionsspezifische Überschreibungen",
        "description": "Optional: Eine Funktion auf ein bestimmtes Modell oder Tier festlegen. Standardmäßig folgt jede Funktion ihrem zugewiesenen Tier.",
        "tier": {
          "high": "High-Tier",
          "low": "Low-Tier",
          "decision": "Decision-Tier"
        },
        "bliksy-chat": {
          "label": "Bliksy-Chat",
          "description": "Interaktiver Aufnahmeassistent."
        },
        "bliksy-modify-subagent": {
          "label": "Bliksy-Modifikations-Subagent",
          "description": "Subagent, der strukturierte Schrittänderungen innerhalb von Bliksy anwendet."
        },
        "step-summary": {
          "label": "Schrittzusammenfassung",
          "description": "Erzeugt Schrittnamen und -beschreibungen nach Abschluss einer Aufnahme."
        },
        "chat-title": {
          "label": "Chat-Titel-Generierung",
          "description": "Erzeugt kurze Titel für Chat-Sitzungen."
        },
        "chat-summarizer": {
          "label": "Konversations-Zusammenfassung",
          "description": "Verdichtet lange Chats zu einer fortlaufenden Zusammenfassung."
        },
        "decision-eval-judge": {
          "label": "Entscheidungs-Bewertung (Evals)",
          "description": "Bewertet Evaluationsläufe mit abgestuften Fragen."
        }
      },
      "appOverride": {
        "title": "App-Modelle"
      },
      "reasoning": {
        "label": "Reasoning-Aufwand",
        "effort": {
          "none": "Aus",
          "low": "Niedrig",
          "medium": "Mittel",
          "high": "Hoch",
          "xhigh": "Sehr hoch",
          "max": "Maximal"
        }
      }
    },
    "superAdmin": {
      "title": "Benutzerverwaltung",
      "description": "Superadmin-Benutzer im System verwalten",
      "inviteUser": "Benutzer einladen",
      "errorLoadingUsers": "Fehler beim Laden der Benutzer",
      "columnEmail": "E-Mail",
      "columnFirstName": "Vorname",
      "columnLastName": "Nachname",
      "columnStatus": "Status",
      "columnInvited": "Eingeladen",
      "columnActivated": "Aktiviert",
      "inviteTitle": "SuperAdmin-Benutzer einladen",
      "inviteDescription": "Sende eine Einladung an einen neuen SuperAdmin-Benutzer. Der Benutzer erhält eine E-Mail mit Anweisungen zur Aktivierung seines Kontos.",
      "inviteSend": "Einladung senden",
      "firstNameRequired": "Vorname ist erforderlich",
      "lastNameRequired": "Nachname ist erforderlich",
      "emailRequired": "E-Mail ist erforderlich",
      "emailInvalid": "Ungültige E-Mail-Adresse",
      "role": "Rolle",
      "roles": {
        "platform_admin": "Plattform-Administration",
        "platform_support": "Support"
      },
      "roleHint": {
        "platform_admin": "Darf alles: Katalog, Nutzer, Einstellungen, Löschen.",
        "platform_support": "Liest Konten, die Liste der Arbeitsbereiche und Protokolle — ändert nichts."
      },
      "roleNone": "Keine Rolle",
      "noAccessTitle": "Kein Bereich freigeschaltet",
      "noAccessBody": "Dieses Konto gehört zur Plattform, trägt aber keine Rolle. Eine Plattform-Administratorin kann sie in der Nutzerverwaltung vergeben.",
      "rolePlaceholder": "Rolle wählen",
      "roleRequired": "Bitte eine Rolle wählen.",
      "changeRole": "Rolle ändern",
      "changeRoleTitle": "Rolle ändern",
      "changeRoleDescription": "Was {{name}} an der Plattform darf.",
      "changeRoleSave": "Speichern"
    }
  }
}
